export class TwoFactor {
  code!: TwoFactorCode;
  blockingTime!: number;
}

export class TwoFactorCode {
  code!: string;
  timestamp!: string;
  triesCount!: number;
}
